import { effect, inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { PaymentManagementActiveState } from '@layout/payment-management-active/store/states/payment-management-active.state';
import {
  LoadPaymentManagementActive,
  SetPaymentManagementInactive,
} from '@layout/payment-management-active/store/actions/payment-management-active.actions';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { isNotUndefined } from '@kaseya-utils';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@kaseya-shared';

@Injectable({
  providedIn: 'root',
})
export class PaymentManagementActiveFacade {
  private readonly store = inject(Store);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly permissionsFacade = inject(PermissionsFacade);
  private readonly hasPaymentManagementView = this.permissionsFacade.hasPermission(Permission.PaymentManagementView);

  readonly isPaymentManagementActive$ = this.store.select(PaymentManagementActiveState.isPaymentManagementActive);
  readonly loading$ = this.store.select(PaymentManagementActiveState.loading);
  readonly error$ = this.store.select(PaymentManagementActiveState.error);

  constructor() {
    this.loadPaymentManagementWhenPermitted();
  }

  loadPaymentManagementActive(): void {
    if (!this.authorizationService.isMigratedUser()) {
      this.store.dispatch(new LoadPaymentManagementActive());
    } else {
      this.setPaymentManagementInactive();
    }
  }

  setPaymentManagementInactive(): void {
    this.store.dispatch(new SetPaymentManagementInactive());
  }

  private loadPaymentManagementWhenPermitted(): void {
    effect(() => {
      if (!isNotUndefined(this.permissionsFacade.permissions())) {
        return;
      }

      if (this.hasPaymentManagementView()) {
        this.loadPaymentManagementActive();
      } else {
        this.setPaymentManagementInactive();
      }
    });
  }
}
